module.exports = __webpack_public_path__ + "img/error.cd814073.svg";